// Capitalize function
export const capitalizeName = (string: string): string => {
  // in order to capitalize composed names
  return string
    .toLowerCase()
    .replace(/(?:^|\s|['`‘’.-])[^\x00-\x60^\x7B-\xDF](?!(\s|$))/g, (s) =>
      s.toUpperCase(),
    );
};
